import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from './Spinner.style';
function Spinner(props) {
    return /*#__PURE__*/ _jsx(Container, {
        size: props.size
    });
}
export default Spinner;
